// extracted by mini-css-extract-plugin
export default {"container_root":"card_container_root__Ab8o1","report_root":"card_report_root__5Wlxu","item":"card_item__QlrK8","big":"card_big__RHO6F","textInner":"card_textInner__TK8bK"};